import { useMutation } from '@apollo/client';

import {
  ExpireBillMutation,
  ExpireBillMutationVariables,
} from '../graphql/generated';
import { EXPIRE_BILL } from '../graphql/mutations';

const useExpireBill = () => {
  const [expireBill, result] = useMutation<
    ExpireBillMutation,
    ExpireBillMutationVariables
  >(EXPIRE_BILL);

  return {
    expireBill,
    ...result,
  };
};

export default useExpireBill;
